/*
 * @Author: @禾子
 * @Date: 2020-08-06 11:52:21
 * @LastEditors: @禾子
 * @LastEditTime: 2020-09-28 14:54:36
 * @Description: 产品、渠道类型
 */
import config from './config';
import utils from '../util/utils';

export default {
    info() {
        return utils.getAppInfo();
    },
    /**
     * @description: 产品是否【清理app】
     * @return {boolean}  result
     */
    isAppClear(phead) {
        if (phead) {
            // console.info('phead=', phead);
            let prdid = phead.prdid;
            if (prdid.toString().length > 5) {
                prdid = prdid / 10;
            }
            return prdid >= 26000 && prdid <= 26999;
        }
        if (config.phead.prdid) {
            let prdid = config.phead.prdid;
            if (prdid.toString().length > 5) {
                prdid = prdid / 10;
            }
            return prdid >= 26000 && prdid <= 26999;
        }
        return false;
    },
    /**
     * @description: 是否 开心答人app
     * @return {boolean} Result 
     */
    isAppHappyAnswer(phead) {
        if (phead) {
            return phead.prdid == '21106' || phead.prdid == '211060';
        }
        if (config.phead.prdid) {
            return config.phead.prdid == "21106" || config.phead.prdid == '211060';
        }
        return false;
    },
    /**
     * @description: Api服务地址 
     * @return {string} clean-service = 清理App   question-service = 答题cocos小游戏
     */
    productService(phead) {
        return this.isAppClear(phead) ? '/clean-service' : '/question-service';
    },
    /**
     * @description: 开心答人B组用户 
     * @return {boolean} 是否开心答人B组用户 
     */
    isHappyAnswerUserB() {
        if ((config.phead.prdid == '211060' || config.phead.prdid == '21106') && utils.userIsB()) {
            return true;
        }
        return false;
    },
    /**
     * @description: 打开客户端小游戏路由拼接  
     * @param {string} param 路由参数 ex:"{"type":"webview","param":{"title":"","isFullScreen":true,"htmlUrl":"http://test.ibestfanli.com/scenead_frontend_service/common?funid=16&appid=1","showTitle":false}}"
     */
    productLaunchRouter(param) {
        console.log('router string ===', param);
        if (!param) {
            return "";
        }
        let prefix = ''; // 不同产品有不同的路由前缀
        let paramObject = JSON.parse(param);
        // let config = paramObject.param;
        // console.log('router json = ', paramObject);
        let router = prefix + '';
        if (this.isAppClear()) {
            prefix = 'clean://com.maizhi.clear.housekeeper/scenead/SceneADLaunch?';
        } else {
            prefix = 'vipgift://com.xmiles.vipgift/web/CommonWebViewActivity?';
        }
        router = `${prefix}type=${paramObject.type}&param=${encodeURIComponent(JSON.stringify(paramObject.param))}`;
        return router;
    }
}